import { searchParamKeys } from '../../shared/configs/searchParams';
import { useSearchParamsSelector } from '../../shared/packages/searchParamsManager';
import {
  parsedAcceptanceSlugsIsEqual,
  parseAcceptanceSlug,
} from '../../shared/packages/acceptance';
import { getBaseOptions } from './helpers';
import {
  acceptanceViewFlatsSelectors,
  useAcceptanceViewFlatsQuery,
} from '../../api/acceptanceViewFlats';

const { acceptance: acceptanceKey } = searchParamKeys;

const dataTypes = {
  original: 'original',
  toMap: 'toMap',
};

const _options = {
  [dataTypes.original]: {},
  [dataTypes.toMap]: {
    select: acceptanceViewFlatsSelectors.toMap,
  },
};

export const useRoomListViewData = ({
  options,
  dataType = dataTypes.original,
} = {}) => {
  const params = useSearchParamsSelector((state) => {
    return parseAcceptanceSlug(state[acceptanceKey]);
  }, parsedAcceptanceSlugsIsEqual);

  const baseOptions = getBaseOptions(_options, dataType, dataTypes.original);

  return useAcceptanceViewFlatsQuery({
    params,
    options: { ...baseOptions, ...options },
  });
};

useRoomListViewData.dataTypes = dataTypes;
